<template>
  <div class="bg-white radius-medium pd-medium br-1px br-grey-transp-15">
    <h4 class="h6 mn-b-thin">{{ plan.name }}</h4>
    <p v-if="plan.description" class="p-small t-grey mn-b-regular">{{ plan.description }}</p>

    <p class="h4 mn-b-regular">
      {{ formattedAmount }}
      <span class="p-small t-grey fw-regular">{{ intervalLabel }}</span>
    </p>

    <div v-if="plan.trialDays > 0" class="pd-small bg-light radius-small mn-b-regular">
      <p class="p-small t-main fw-medium">{{ $t('plans.trial', { days: plan.trialDays }) }}</p>
    </div>

    <ul v-if="plan.features?.length" class="mn-b-medium">
      <li
        v-for="(feature, i) in plan.features"
        :key="i"
        class="d-flex flex-v-center gap-small mn-b-thin"
      >
        <span class="t-main p-small">✓</span>
        <span class="p-small">{{ feature }}</span>
      </li>
    </ul>

    <Button class="w-100" @click="$emit('select', plan)">
      {{ $t('plans.selectPlan') }}
    </Button>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import Button from '@martyrs/src/design-system/components/Button/Button.vue';

const props = defineProps({
  plan: { type: Object, required: true },
});

defineEmits(['select']);

const formattedAmount = computed(() => {
  const value = props.plan.amount?.value || 0;
  const currency = props.plan.amount?.currency || 'RUB';
  return `${(value / 100).toLocaleString('ru-RU')} ${currency === 'RUB' ? '₽' : currency}`;
});

const intervalLabel = computed(() => {
  const labels = { day: '/день', week: '/нед', month: '/мес', year: '/год' };
  const count = props.plan.intervalCount || 1;
  const base = labels[props.plan.interval] || '';
  return count > 1 ? `/ ${count} ${props.plan.interval}` : base;
});
</script>
